<template lang="html">
  <div class="modal fade-in">
    <div class="container slide-in">
      <!-- Single player scores -->
      <div v-if="mode">
        <h1> {{ playerName }}</h1>
        <h2>תוצאה : {{ scores.playerOne.total }}/10</h2>
        <p style="direction:rtl; margin:10px;">{{ scoreMessage }}</p>
      </div>
      <!-- Multiplayer scores -->
      <div v-if="!mode">
        <!-- Win conditions -->
        <h1 v-if="scores.playerOne.total > scores.playerTwo.total">Player One Wins!</h1>
        <h1 v-if="scores.playerTwo.total > scores.playerOne.total">Player Two Wins!</h1>
        <h1 v-if="scores.playerOne.total === scores.playerTwo.total">Draw!</h1>
        <!-- Results -->
        <h2>Player One: <span :class="scores.playerOne.total >= scores.playerTwo.total ? 'score-high' : 'score-low'">{{ scores.playerOne.total }}</span></h2>
        <h2>Player Two: <span :class="scores.playerTwo.total >= scores.playerOne.total ? 'score-high' : 'score-low'">{{ scores.playerTwo.total }}</span></h2>
      </div>
      <!-- Restart game buttons -->
      <button @click="newGame(true)">משחק חדש</button>
<!--      <button @click="sendScore()">send</button>
      <button v-if="!mode" @click="newGame(false)">Rematch!</button>-->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      playersList: []
    }
  },
  computed: {
    mode() {
      return this.$store.getters.mode;
    },
    playerName() {
      return this.$store.getters.playerName;
    },
    scores() {
      return this.$store.state.scores;
    },
    // Award message for solo mode
    scoreMessage() {
      const cases = {
        0: "ממש אין לך שום הבנה מה זה מחשב ",
        1: 'שאלה אחת זה הכל אתה מסוגל ליותר',
        2: 'גם אם היינו נותנים לתינוק הוא היה מצליח יותר',
        3: "3 תשובות נכונות ת באמת זה לא כל כך קשה",
        4: "אל תדאג 4/10 זה הממוצא.",
        5: 'חצי נכון ת נסתקל על החצי כוס המלאה',
        6: 'יש לך עתיד אבל עדיין לא שם',
        7: 'כל הכבוד רק 3 תשובות לא נכונות',
        8: "אתה בדרך להיות מסטר ,אף אחד לא מושלם",
        9: 'כל הכבוד כמעט מושלם',
        10: 'מצוין יש לך עתיד מזהיר בעולם המחשבים',
      };
      let score = this.scores.playerOne.total;
      if (score) {
        return cases[score];
      } else {
        return '';
      }
    }
  },
  methods: {
    newGame(payload) {
      this.$store.commit('resetGame');
      if (payload) {
        this.$store.commit('newGame');
      } else {
        this.$store.dispatch('startGame');
      }
    },

    sendScore() {

      let player = {
        playerName:this.playerName,
        score: this.scores.playerOne.total,
        time: new Date()
      }
 //     window.location=`https://trivia.voicenter-ltd.workers.dev/?playerName=${this.playerName}&score=${this.scores.playerOne.total}&time=${new Date()}  `;
    const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      const raw = JSON.stringify(player);

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
        referrerPolicy: "no-referrer-when-downgrade"
      };
      let that = this ;

      fetch("https://trivia.voicenter-ltd.workers.dev/", requestOptions)
          .then(response => response.text())
          .then(result =>{
            console.log(result);
          /*  that.playersList=JSON.parse(result);
            this.$store.commit('playersList',   that.playersList);*/
          })
          .catch(error => console.error('error', error));
      console.log("Going to post player data ",player,that)
      setTimeout(() => {this.newGame(true)},15000)
    }
  },
  created(){
    this.sendScore();
  },
}
</script>

<style lang="scss" scoped>@import ".././main.scss";

button {
  background-color: $color-med;
  border: 2px solid $color-med;
  color: $color-white;
  width: 90%;
  &:first-child {
    margin-top: 2em;
  }
}

h1, p {
  color: $color-darkest;
}

h2 {
  color: $color-dark;
}

.container {
  background-color: $color-white;
  border-radius: 25px;
  color: $color-med;
  margin-top: 4em;
  padding: 2em 2.5%;
  //height: 500px;
}

.modal {
  align-items: center;
  animation: fade-in .75s ease forwards; // defined in main.scss
  background-color: rgba(0, 0, 0, .5);
  display: flex;
  flex-direction: column;
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 9999;
}

.slide-in {
  animation: slide-in .75s ease forwards;
}

@keyframes slide-in {
  0% {
    opacity: 0;
    transform: translateY(-400px);
  }
  25% {
    transform: translateY(100px);
  }
  75% {
    opacity: 1;
  }
  100% {
    transform: translateY(0);
  }
}

@media (hover:hover) {
  button:hover {
    background-color: $color-white;
    border: 2px solid $color-med;
    color: $color-med;
  }
}

@media (max-width: 600px) {
  .container {
    width: 85%;
  }
}

@media (min-width: 600px) {
  .container {
    width: 500px;
  }
}
</style>



// WEBPACK FOOTER //
// GameOverModal.vue?26e1a0f1